import { useContext } from "react";
import { __RouterContext } from "react-router";
const useReactRouter = () => {
    const routerContext = useContext(__RouterContext);
    return routerContext;
};
export default useReactRouter;
